// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs--zNK","tab":"Tabs_tab--RLe","active":"Tabs_active--OXL","counter":"Tabs_counter--L2N","link":"Tabs_link--IP_"};